// extracted by mini-css-extract-plugin
export default {"wrapper":"Lr-z","response":"Mr-z","error":"Nr-z","disabled":"Or-z","buttons":"Pr-z","feedbackQuestionSection":"Qr-z","yesNoWrapper":"Rr-z"};